import React from 'react';

interface AlgorithmButtonsProps {
  handleCopy: () => void | undefined;
  handleMoveUp: () => void | undefined;
  handleMoveDown: () => void | undefined;
  handleDeleteStep: () => void | undefined;
}

export const AlgorithmButtons: React.FC<AlgorithmButtonsProps> = ({
  handleCopy,
  handleMoveUp,
  handleMoveDown,
  handleDeleteStep
}) => {
  return (
    <div className="d-flex gap-2 flex-shrink-0">
      <div
        className="material-symbols-outlined text-primary cursor-pointer text-decoration-none"
        style={{ fontSize: '1rem' }}
        title="Move Up"
        onClick={(e) => {
          e.stopPropagation();
          handleMoveUp();
        }}>
        move_up
      </div>

      <div
        className="material-symbols-outlined text-primary cursor-pointer text-decoration-none"
        style={{ fontSize: '1rem' }}
        title="Move Down"
        onClick={(e) => {
          e.stopPropagation();
          handleMoveDown();
        }}>
        move_down
      </div>

      <div
        className="material-symbols-outlined text-primary cursor-pointer text-decoration-none"
        style={{ fontSize: '1rem' }}
        title="Copy"
        onClick={(e) => {
          e.stopPropagation();
          handleCopy();
        }}>
        content_copy
      </div>

      <div
        className="material-symbols-outlined text-danger cursor-pointer text-decoration-none"
        style={{ fontSize: '1rem' }}
        title="Delete"
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteStep();
        }}>
        delete
      </div>
    </div>
  );
};
